var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJoinRoomIcon = function SvgJoinRoomIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.366 2.282h-4.9a.82.82 0 0 1-.818-.817.82.82 0 0 1 .817-.817h4.901c.899 0 1.634.736 1.634 1.634v11.436c0 .899-.735 1.634-1.634 1.634h-4.9a.82.82 0 0 1-.818-.817.82.82 0 0 1 .817-.817h4.901z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.272 7.714 7.993 5.435a.41.41 0 0 0-.702.286v1.462H1.573A.82.82 0 0 0 .756 8c0 .45.367.817.817.817H7.29v1.462c0 .368.44.548.694.286l2.28-2.279a.4.4 0 0 0 .007-.572"
  })));
};
export default SvgJoinRoomIcon;